var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVolumeMute(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.253,
    height: 20.247,
    viewBox: "0 0 29.253 20.247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "volume-mute",
    transform: "translate(-2.25 -7.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M15.113,7.987A1.125,1.125,0,0,1,15.75,9V27a1.125,1.125,0,0,1-1.827.878L8.606,23.625H3.375A1.125,1.125,0,0,1,2.25,22.5v-9a1.125,1.125,0,0,1,1.125-1.125H8.606l5.317-4.252a1.125,1.125,0,0,1,1.19-.135ZM13.5,11.34,9.7,14.377a1.125,1.125,0,0,1-.7.248H4.5v6.75H9a1.125,1.125,0,0,1,.7.247l3.8,3.038ZM31.172,12.7a1.125,1.125,0,0,1,0,1.593l-9,9A1.126,1.126,0,1,1,20.579,21.7l9-9a1.125,1.125,0,0,1,1.593,0Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M20.579,12.7a1.125,1.125,0,0,0,0,1.593l9,9A1.126,1.126,0,1,0,31.172,21.7l-9-9a1.125,1.125,0,0,0-1.593,0Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMute);
export default __webpack_public_path__ + "static/media/volume-mute.cea87883330fb9513597b17a96116aab.svg";
export { ForwardRef as ReactComponent };